import _toConsumableArray from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import Cookies from "universal-cookie";
import merge from "lodash/merge";

var TrackingUtil = /*#__PURE__*/function () {
  function TrackingUtil() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, TrackingUtil);

    // If `window` is not available don't do anything
    if (typeof window === "undefined") {
      return null;
    } // If the tracking is already set don't do anything


    if (window.trackingUtil) return null; // Default options

    this.options = {
      enabled: true,
      cookie: {
        name: "tracking-util-reacted",
        options: {
          path: "/",
          maxAge: 3600 * 24 * 365,
          // year
          secure: false
        }
      },
      services: {
        gtm: {
          id: "",
          dataLayerName: "dataLayer"
        },
        ga: {
          id: "",
          commandQueue: "ga",
          createFields: {}
        }
      }
    };
    merge(this.options, options);
    this.status = {
      userReacted: false,
      trackingAccepted: null,
      defaultGTMdataLayer: [],
      defaultGAcommands: []
    };
    this.cookies = new Cookies();
    this.init();
    window.trackingUtil = this;
  }
  /*
   * Init scripts if tracking's accepted
   */


  _createClass(TrackingUtil, [{
    key: "init",
    value: function init() {
      var cookie = this.cookies.get(this.options.cookie.name);

      if (!cookie) {
        this.status = _objectSpread(_objectSpread({}, this.status), {}, {
          userReacted: false
        });
        return null;
      }

      if (cookie.accepted === true || cookie.accepted === "true") {
        this.status = _objectSpread(_objectSpread({}, this.status), {}, {
          userReacted: true,
          trackingAccepted: true,
          defaultGTMdataLayer: cookie.defaultGTMdataLayer,
          defaultGAcommands: cookie.defaultGAcommands
        });
        this.initTrackers();
        return true;
      }

      this.status = _objectSpread(_objectSpread({}, this.status), {}, {
        userReacted: true,
        trackingAccepted: false
      });
      return false;
    }
    /*
     * Checks if user has made a decision to allow or deny tracking
     */

  }, {
    key: "userReacted",
    value: function userReacted() {
      return this.status.userReacted;
    }
    /*
     * Checks if tracking has been accepted by user
     */

  }, {
    key: "trackingAccepted",
    value: function trackingAccepted() {
      return this.status.trackingAccepted;
    }
    /*
     * Sets tracking decision and starts tracking if accepted
     *
     * @param {bool} value `true` if accepted, `false` if denied
     * @param {object} options
     *   @param defaultGTMdataLayer {array} Default GTM data layer
     *   @param defaultGAcommands {array} Default GA data
     */

  }, {
    key: "setTrackingAccepted",
    value: function setTrackingAccepted(value) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$defaultGTMda = options.defaultGTMdataLayer,
          defaultGTMdataLayer = _options$defaultGTMda === void 0 ? [] : _options$defaultGTMda,
          _options$defaultGAcom = options.defaultGAcommands,
          defaultGAcommands = _options$defaultGAcom === void 0 ? [] : _options$defaultGAcom;
      this.cookies.set(this.options.cookie.name, {
        accepted: value,
        defaultGTMdataLayer: defaultGTMdataLayer,
        defaultGAcommands: defaultGAcommands
      }, this.options.cookie.options);
      this.init();
      return true;
    }
    /*
     * Initiates tracking
     */

  }, {
    key: "initTrackers",
    value: function initTrackers() {
      this.initGTM();
      this.initGA();
    }
    /*
     *
     *
     * GTM
     *
     *
     */

    /*
     * Checks if enough options provided to perform GTM tracking
     */

  }, {
    key: "isGTMtrackable",
    value: function isGTMtrackable() {
      var gtm = this.options.services.gtm;
      return gtm && gtm.id && gtm.dataLayerName;
    }
    /*
     * Initiates GTM tracking
     */

  }, {
    key: "initGTM",
    value: function initGTM() {
      var _this = this;

      if (!this.options.enabled || !this.trackingAccepted() || !this.isGTMtrackable()) {
        return false;
      }

      var gtm = this.options.services.gtm;
      var defaultGTMdataLayer = this.status.defaultGTMdataLayer;

      (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({
          "gtm.start": new Date().getTime(),
          event: "gtm.js"
        });
        var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", gtm.dataLayerName, gtm.id);
      /* eslint-enable */


      if (Array.isArray(defaultGTMdataLayer)) {
        defaultGTMdataLayer.forEach(function (dl) {
          return _this.registerGTMdata(dl);
        });
      }

      return true;
    }
    /*
     * Registers GTM data
     *
     * @param {object} data
     * @returns {bool} `true` on success and `false` on failure
     */

  }, {
    key: "registerGTMdata",
    value: function registerGTMdata(data) {
      if (!this.options.enabled || !this.trackingAccepted() || !this.isGTMtrackable() || typeof data !== "object") {
        return false;
      }

      var dataLayerName = this.options.services.gtm.dataLayerName;

      if (!Array.isArray(window[dataLayerName])) {
        return false;
      }

      window[dataLayerName].push(data);
      return true;
    }
    /*
     * Gets registered GTM data
     * @returns {array}
     */

  }, {
    key: "registeredGTMdata",
    value: function registeredGTMdata() {
      if (!this.options.enabled || !this.trackingAccepted() || !this.isGTMtrackable()) {
        return [];
      }

      var dataLayerName = this.options.services.gtm.dataLayerName;

      if (!Array.isArray(window[dataLayerName])) {
        return [];
      }

      return window[dataLayerName];
    }
    /*
     *
     *
     * GA
     *
     *
     */

    /*
     * Checks if enough options provided to perform GA tracking
     */

  }, {
    key: "isGAtrackable",
    value: function isGAtrackable() {
      var ga = this.options.services.ga;
      return ga && ga.id && ga.commandQueue;
    }
    /*
     * Initiates GA tracking
     */

  }, {
    key: "initGA",
    value: function initGA() {
      var _this2 = this;

      if (!this.options.enabled || !this.trackingAccepted() || !this.isGAtrackable()) {
        return false;
      }

      var ga = this.options.services.ga;
      var defaultGAcommands = this.status.defaultGAcommands;

      (function (i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        i[r] = i[r] || function () {
          ;
          (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(window, document, "script", "https://www.google-analytics.com/analytics.js", ga.commandQueue);
      /* eslint-enable */


      this.runGAcommand(["create", ga.id, ga.createFields]);

      if (Array.isArray(defaultGAcommands)) {
        defaultGAcommands.forEach(function (d) {
          return _this2.runGAcommand(d);
        });
      }

      return true;
    }
    /*
     * Runs GA command
     *
     * @param {array} data Command params
     * @returns {bool} `true` on success and `false` on failure
     */

  }, {
    key: "runGAcommand",
    value: function runGAcommand(data) {
      var _window;

      if (!this.options.enabled || !this.trackingAccepted() || !this.isGAtrackable() || !Array.isArray(data)) {
        return false;
      }

      var commandQueue = this.options.services.ga.commandQueue;

      if (typeof window[commandQueue] !== "function") {
        return false;
      }

      (_window = window)[commandQueue].apply(_window, _toConsumableArray(data));

      return true;
    }
  }]);

  return TrackingUtil;
}();

export default TrackingUtil;